import React from 'react';
import { useTranslation } from 'react-i18next';
import DurationDaysField from 'components/DurationDaysField';
import CheckIcon from 'icons/Check.icon';
import ResolvePopup from 'components/ResolvePopup';
import InformationcircleIcon from 'icons/Informationcircle.icon';

import './ExpirationChecklistItem.styles.scss';

type ExpirationChecklistItemProps = {
  isSelected: boolean;
};

const ExpirationChecklistItem: React.FC<ExpirationChecklistItemProps> = (
  props,
) => {
  const { isSelected } = props;

  const { t } = useTranslation();

  const name = isSelected ? 'expirationDays' : 'expirationDaysPlaceholder';

  return (
    <div className="checklist-item">
      <CheckIcon />
      <DurationDaysField
        name={name}
        label={t('downloadsExpireAfter')}
        placeholder="14"
        disabled={!isSelected}
      >
        <ResolvePopup onHover popupContent={t('downloadsExpireAfterTooltip')}>
          <InformationcircleIcon />
        </ResolvePopup>
      </DurationDaysField>
    </div>
  );
};

export default ExpirationChecklistItem;
